import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
  getEcosystemApps,
  getMyCertificates,
  getMyEntitlements,
  getStoredUser,
  type AccountEntitlement,
  type EcosystemApp,
} from '../../lib/api'
import { EcosystemAppsGrid } from '../../components/EcosystemAppsGrid'

export function InicioSection() {
  const storedUser = getStoredUser()
  const firstName = storedUser?.name?.split(' ')[0] ?? ''

  const [apps, setApps] = useState<EcosystemApp[]>([])
  const [entitlements, setEntitlements] = useState<AccountEntitlement[]>([])
  const [isLoadingApps, setIsLoadingApps] = useState(true)
  const [certificateCount, setCertificateCount] = useState<number | null>(null)

  useEffect(() => {
    let cancelled = false

    Promise.all([getEcosystemApps(), getMyEntitlements()])
      .then(([appsResult, entitlementsResult]) => {
        if (cancelled) return
        setApps(appsResult)
        setEntitlements(entitlementsResult)
      })
      .catch(() => {
        // Best-effort — the section still renders an empty grid.
      })
      .finally(() => {
        if (!cancelled) setIsLoadingApps(false)
      })

    getMyCertificates()
      .then((result) => {
        if (!cancelled) setCertificateCount(result.length)
      })
      .catch(() => {
        // Best-effort — the certificates card just doesn't render.
      })

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <section>
      <p className="account-section__eyebrow">SateLab</p>
      <h1 className="account-section__title">{firstName ? `Hola, ${firstName}` : 'Hola'}</h1>
      <p className="account-section__subtitle">Este es tu espacio para entrar a tus apps y ver tu progreso.</p>

      <div className="account-section__body" style={{ display: 'flex', flexDirection: 'column', gap: '1.75rem' }}>
        <div>
          <h2 className="account-inline-title">Tus apps</h2>
          <EcosystemAppsGrid apps={apps} isLoading={isLoadingApps} entitlements={entitlements} />
        </div>

        {certificateCount !== null && certificateCount > 0 && (
          <Link to="/cuenta/certificados" className="account-highlight-card">
            <span className="account-highlight-card__icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="6" />
                <path d="M9 13.5 6 22l6-3.2 6 3.2-3-8.5" />
              </svg>
            </span>
            <span className="account-highlight-card__text">
              <span className="account-highlight-card__title">
                {certificateCount} {certificateCount === 1 ? 'certificado obtenido' : 'certificados obtenidos'}
              </span>
              <span className="account-highlight-card__subtitle">Toca para ver tus certificados</span>
            </span>
            <svg
              className="account-highlight-card__chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 6l6 6-6 6" />
            </svg>
          </Link>
        )}
      </div>
    </section>
  )
}
